import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/chapter'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(chapter) {
    return http.post(`${resource}`, chapter)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(chapter, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, chapter)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
